import apiClient from '@/api/index'
import router from '@/router';

export const reportDDSModule = {
    namespaced: true,

    state:() => ({
        reportData: {},
        reportLoading: true,
        reportFilterset: {},
        filtersetLoading: true,
        filterSpecs: {},
        defaultDate: null,
        defaultMonth: null,
        excelData: {},
        prevData: null,
        points_of_sale: null,
        DDSArticles: null,
        preorderSuccess: false,
    }),

    mutations: {
        setReportData(state, data) {
            state.reportData = data
        },

        setReportFilterset(state, data) {
            state.filterSpecs['month_range'] = []

            if(Object.keys(router.currentRoute.value.query).length == 0) {
                for(let filter in data) {
                    if(filter !== 'title') {
                        for(let i = 0; i < data[filter].choices.length; i++) {
                            if(filter === 'month_range') {
                                state.filterSpecs[filter].push(data[filter].choices[i].value)
                            } else if (filter == 'date_range') {
                                state.filterSpecs[filter] = data[filter].choices[i].query
                            } else {
                                if(data[filter].multi_choices) {
                                    if(data[filter].choices[i].checked) {
                                        state.filterSpecs[filter].push(data[filter].choices[i].value)
                                    }
                                } else {
                                    if(data[filter].choices[i].checked) {
                                        state.filterSpecs[filter] = data[filter].choices[i].value
                                    }
                                }
                                
                            }
                        }
                    }
                }
            } else {
                const queries = router.currentRoute.value.query
                state.filterSpecs['month_range'] = []

                if(queries.shop) {
                    if(Array.isArray(queries.shop)) {
                        state.filterSpecs['shop'] = queries.shop
                    } else {
                        state.filterSpecs['shop'] = [Number(queries.shop)]
                    }
                }

                queries.month_from ?
                    state.filterSpecs['month_range'][0] = {
                        month: Number(queries.month_from.split("-")[1] - 1),
                        year: Number(queries.month_from.split("-")[0])
                    }
                    : state.filterSpecs['month_range'][0] = ''
                    
                queries.month ?
                    state.filterSpecs['month_range'][1] = {
                        month: Number(queries.month.split("-")[1] - 1),
                        year: Number(queries.month.split("-")[0])
                    }
                    : state.filterSpecs['month_range'][1] = ''

                queries.date_to ? state.filterSpecs['date_range'] = queries.date_to : state.filterSpecs['date_range'] = ''
            }

            state.reportFilterset = data
            state.filtersetLoading = false
        },

        setExcelData(state, data) {
            state.excelData = data
        },

        setPrevData(state, data) {
            state.prevData = data
        },

        setPointsOfSale(state, data) {
			state.points_of_sale = data
			for(let i = 0; i < data.length; i++) {
				state.points_of_sale[i].label = data[i].name
				state.points_of_sale[i].value = data[i].id
			}
		},

        setDDSArticles(state, data) {
            for(let i = 0; i < data.length; i++) {
                data[i].label = data[i].name + ' - ' + data[i].summary_name
                data[i].value = data[i].id
            }

            state.DDSArticles = data
        },

        setPreorderStatus(state, bool) {
            state.preorderSuccess = bool
        },
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true
            // Проверяет, есть ли параметры которые можно передать в запросе
            if(router.currentRoute.value.fullPath.split('?')[1]) {
                try {
                    const response = await apiClient.get("/reports/dds/data?" + router.currentRoute.value.fullPath.split('?')[1], {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    commit('setReportData', response.data.data)
                    commit('setExcelData', response.data)
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            // Если нет, делать запрос без параметров
            } else {
                try {
                    const response = await apiClient.get("/reports/dds/data", {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    commit('setReportData', response.data.data)
                    commit('setExcelData', response.data)
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            }
            state.reportLoading = false
        },

        async preorderReportData({ commit, state }, comment) {
            // Проверяет, есть ли параметры которые можно передать в запросе
            if(router.currentRoute.value.fullPath.split('?')[1]) {
                try {
                    const response = await apiClient.get("/reports/dds/data?preorder="+ comment + "&" + router.currentRoute.value.fullPath.split('?')[1], {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })

                    state.preorderSuccess = true
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            // Если нет, делать запрос без параметров
            } else {
                try {
                    const response = await apiClient.get("/reports/dds/data?preorder=" + comment, {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })

                    state.preorderSuccess = true
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            }
        },

        async getReportFilterset({ commit, state }) {
            try {
                const response = await apiClient.get("/reports/dds/filterset", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                commit('setReportFilterset', response.data)
                state.filtersetLoading = false
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },

        resetFilters({ state }) {
            state.filterSpecs['shop'] = state.reportFilterset['shop'].choices[0].value
        },

        async getExcelFile({ state }) {
            try {
                const response = await apiClient.post("/reports/export_to_excel/",
                state.excelData,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    },
                    responseType: 'blob'
                })
                const url = URL.createObjectURL(response.data)
                const a = document.createElement('a')
                a.href = url
                a.download = 'report_dds.xls'
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
                URL.revokeObjectURL(url)
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },

        async changeValue({ dispatch }, data) {
            if(data.data.predict_type_calc) {
                try {
                    const response = await apiClient.patch("/reports/dds/edit/items/" + data.id + '/', {
                        predict_type_calc: data.data.predict_type_calc,
                        predict_value: data.data.predict_value,
                        predict_is_manual: true
                    },
                    {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    dispatch('getReportData')
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            } else if (data.data.plan_type_calc) {
                try {
                    const response = await apiClient.patch("/reports/dds/edit/items/" + data.id + '/', {
                        plan_type_calc: data.data.plan_type_calc,
                        plan_value: data.data.plan_value,
                        plan_is_manual: true
                    },
                    {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    dispatch('getReportData')
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            } else if (data.data.fact_type_calc) {
                try {
                    const response = await apiClient.patch("/reports/dds/edit/items/" + data.id + '/', {
                        fact_type_calc: data.data.fact_type_calc,
                        fact_value: data.data.fact_value,
                        fact_is_manual: true
                    },
                    {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    dispatch('getReportData')
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            } else if (Object.keys(data.data)[0] == 'description') {
                try {
                    const response = await apiClient.patch("/reports/dds/edit/items/" + data.id + '/', {
                        description: data.data.description
                    },
                    {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    dispatch('getReportData')
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            }
        },

        async getPrevData({ commit, dispatch }, data) {
            try {
                const response = await apiClient.get("/reports/dds/edit/copy/?shop="+ data.shop +"&month="+ data.month + '&force=true', {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                commit('setPrevData', response.data)
                dispatch('getReportData')
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },

        async resetValue({ commit, dispatch }, data) {
            if(data.data.predict_type_calc) {
                try {
                    const response = await apiClient.patch("/reports/dds/edit/items/" + data.id + '/', {
                        predict_type_calc: 'amount',
                        predict_value: 0,
                        predict_is_manual: false
                    },
                    {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    dispatch('getReportData')
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            } else if (data.data.plan_type_calc) {
                try {
                    const response = await apiClient.patch("/reports/dds/edit/items/" + data.id + '/', {
                        plan_type_calc: 'amount',
                        plan_value: 0,
                        plan_is_manual: false
                    },
                    {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    dispatch('getReportData')
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            } else if (data.data.fact_type_calc) {
                try {
                    const response = await apiClient.patch("/reports/dds/edit/items/" + data.id + '/', {
                        fact_type_calc: 'amount',
                        fact_value: 0,
                        fact_is_manual: false
                    },
                    {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    dispatch('getReportData')
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            }
        },

        async getPointOfSale({ commit, state }) {
			try {
				const response = await apiClient.get("/projects/tcode/shops/", {
					headers: {
						Authorization: 'Token ' + localStorage.getItem('token')
					}
				})
				commit('setPointsOfSale', response.data)
			} catch (err) {
				alert(err)
			}
		},

        async getDDSArticles({ commit }) {
            try {
                const response = await apiClient.get("/projects/tcode/articles-dds/", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                commit('setDDSArticles', response.data)
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },

        async setBills({}, data) {
            try {
                const response = await apiClient.post("/projects/tcode/bills/",
                data,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        }
    }
}